import { Assignment as ProjekteIcon, AssignmentInd as KundenIcon } from '@mui/icons-material';
import { Box, LinearProgress } from '@mui/material';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

import { PlainEntityDetailsHeader } from '../../../components/plainEntityDetailsHeader/PlainEntityDetailsHeader';
import { RouterTabs } from '../../../components/routerTabs/RouterTabs';
import { ProjektTable } from '../../projekt/list/ProjektTable';
import { useFindKundeByIdQuery } from '../api/kundeApi';

import { KundeStammdatenCard } from './KundeStammdatenCard';

export const KundeViewScreen: FC = () => {
  const { id } = useParams();
  const { data, isLoading } = useFindKundeByIdQuery(id as string);

  return (
    <Box>
      {isLoading && <LinearProgress sx={{ width: '100%' }} />}
      {data && (
        <>
          <PlainEntityDetailsHeader
            title={data.organisation}
            createdAt={data.creationDate}
            updatedAt={data.updateDate}
          />
          <RouterTabs
            tabs={[
              {
                index: true,
                path: 'kunde',
                label: 'Kunde',
                icon: <KundenIcon />,
                content: (
                  <Box
                    sx={{
                      width: '50%',
                    }}
                  >
                    <KundeStammdatenCard kunde={data} />
                  </Box>
                ),
              },
              {
                path: 'projekte',
                label: 'Projekte',
                icon: <ProjekteIcon />,
                content: (
                  <ProjektTable
                    initialFilterItems={{ kundeId: { value: id, operator: 'equal' } }}
                  />
                ),
              },
            ]}
          />
        </>
      )}
    </Box>
  );
};
